'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import TopNav from './TopNav';
import { useAuth } from '@/contexts/AuthContext';

interface AppLayoutProps {
  children: React.ReactNode;
  fullscreen?: boolean;
}

export default function AppLayout({ children, fullscreen = false }: AppLayoutProps) {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && !user) {
      router.replace('/login');
    }
  }, [user, loading, router]);

  if (loading) {
    return (
      <div className="h-app-screen bg-background flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="h-app-screen bg-background flex flex-col overflow-hidden">
      <TopNav />
      <main className={fullscreen ? 'flex-1 flex flex-col overflow-hidden' : 'flex-1 overflow-auto'}>
        {children}
      </main>
    </div>
  );
}